<!--
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-14 12:05:24
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-14 17:51:19
 * @FilePath: \pc\coursearrange\src\dataBoard\dataBoard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="padding: 20px 0px 0px 20px;">

      <el-form style="display: flex;flex-wrap: wrap;">
            <el-form-item label="老师姓名:" style="display: flex;width: 33%;">
                <el-select placeholder="请选择老师姓名" v-model="input1" style="width: 100%" clearable filterable>
                    <el-option v-for="item in options"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="日期:" style="display: flex;width: 33%;">
              <el-date-picker  v-model="input2" type="date" style="width: 100%;" value-format="yyyy-MM-dd" placeholder="请选择日期" clearable></el-date-picker>
            </el-form-item>

            <div style="display: flex;justify-content: end;width: 100%;margin-bottom: 30px; margin-top: 6px;">
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
            </div>

        </el-form>


        <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
            <el-table-column prop="customerStudent" label="老师姓名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="customerIsallpay" label="五节规划课成交率" show-overflow-tooltip></el-table-column>
            <el-table-column prop="customerIsallpay" label="现有学员出勤率" show-overflow-tooltip></el-table-column>
            <el-table-column prop="customerIsallpay" label="现有学员留存率" show-overflow-tooltip></el-table-column>
            <el-table-column prop="customerIsallpay" label="周测成绩及培训考核成绩达标次数占三个月内总考试次数百分比" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                    <div style="display: flex;justify-content: space-around;">
                        <el-button type="text" style="color:#00aaff;" @click="handleClickView(1, scope.row)">降级</el-button>
                        <el-button type="text" style="color:#00aaff;" @click="handleClickView(2, scope.row)">详情</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pageNum" :page-size="pageSize"
            layout="prev, pager, next,sizes, jumper" :total="total">
        </el-pagination>


        <el-dialog  :center="true" :close-on-click-modal="false" title="详情" :visible.sync="titleDialogShowvisible"  @close="titlerejectDialogShowClr" width="70%">
            <el-form  label-width="100px">
                <el-form-item label="老师职级:">
                    <span>张三</span>
                </el-form-item>
                <el-form-item label="五节规划课成交率:">
                    <span>80%</span>
                </el-form-item>
                <el-form-item label="现有学员出勤率:">
                    <span>80%</span>
                </el-form-item>
                <el-form-item label="现有学员留存率:">
                    <span>80%</span>
                </el-form-item>
                <el-form-item label="三项总百分比之和:">
                    <span>80%</span>
                </el-form-item>
                <el-form-item label="周测成绩及培训考核成绩达标次数占三个月内总考试次数百分比:">
                    <span>80%</span>
                </el-form-item>
                <el-form-item label="日期:">
                    <span>2024-06-01</span>
                </el-form-item>
            </el-form>
        </el-dialog>


        <el-dialog  :center="true" :close-on-click-modal="false" title="降级" :visible.sync="titleDialogShowvisible1"  @close="titlerejectDialogShowClr1" width="70%">
            <el-form label-width="100px">
                <el-form-item label="降级原因:">
                  <el-input type="textarea" placeholder="请输入降级原因" maxlength="300" show-word-limit v-model="textareainput" :autosize="{ minRows: 6, maxRows: 6 }"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" class="btns" @click="titlerejectDialogShowClr1">取 消</el-button>
                <el-button size="small" class="btns" type="primary" @click="titlerejectDialogShowSubt1">确 定</el-button>
            </div>
        </el-dialog>


  </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { handleStudent, handleTeacher } from "../utils/publicInterface";
import { getStudentsType } from "@/api/fiveClassApi"
import { getTeachers } from "@/api/fiveClassApi"

export default {
  components:{

  },
  data() {
      return{

          options:[ ],

          input1:'',
          input2:'',

          dataList:[],

          pageNum: 1,
          pageSize: 10,
          total: 0,

          form:{
              input1:'',
              input2:true,
              input3:'',
          },

          titleDialogShowvisible:false,
          titleDialogShowvisible1:false,
          textareainput:'',

      }
  },

  mounted(){
    getTeachers().then(res => {  this.options = res.data })
  },


  methods:{


      getApiList(){
          let data = {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              commitId: this.input1,
          }
          axios.post(`${apiBaseUrl}/orderCustomerAudit/find`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {

                if(res.data.code === 200){

                  let data = res.data.data
                  this.dataList = data.records
                  this.pageNum = data.current ? data.current : 0
                  this.pageSize = data.size ? data.size : 10
                  this.total = data.total ? data.total : 0

                  this.$message({ message: res.data.message , type: "success" })
                }
          }).catch((err)=>{
              this.$message({ message: err , type: "error" })
          })
      },


      titlerejectDialogShowClr(){
        this.titleDialogShowvisible = false
      },

      titlerejectDialogShowClr1(){
        this.textareainput = ''
        this.titleDialogShowvisible1 = false
      },

      titlerejectDialogShowSubt1(){
        if(this.textareainput){
          this.textareainput = ''
          this.titleDialogShowvisible1 = false
        }else{
          this.$message({ message: '请填写降级原因~' , type: "warning" })
        }
      },

      searchBtns(){
          this.getApiList()
      },

      clearBtns(){
          this.input1 = ''
          this.input2 = ''
          this.getApiList()
      },

      handleSizeChange(e){
          this.pagepageSizeNum = e
          this.getApiList()
      },

      handleCurrentChange(e){
          this.pageNum = e
          this.getApiList()
      },

      handleClickView(type,itme){
        console.log(itme)
        if(type === 2){
          this.titleDialogShowvisible = true
        }
        if(type === 1){
          this.titleDialogShowvisible1 = true
        }

      },

  }

}
</script>


<style scoped lang="less">

  .no-click {
      pointer-events: none;
  }

  .btns{
      background-color: #428BCA;
      border-color: #428BCA;
      color: #fff;
  }


</style>



// WEBPACK FOOTER //
// src/IntermediateTeacherGradeProtectionManagement/IntermediateTeacherGradeProtectionManagement.vue